export const formatLink = link => {
  return `https://${link.replace(/^(https?):\/\//, "")}`
}
